import {Pipe, PipeTransform} from "@angular/core";
import {LegalForm} from "../../model/legalForm";

@Pipe({name: 'companyForm'})
export class CompanyFormPipe implements PipeTransform {
    transform(value: any) {
        return LegalForm[value];
    }
}
